<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
export default {
  name: 'editsurvey',
  components: {
    FormWizard,
    TabContent
  },
  data () {
    return {
      surveyLoading: true,
      salesPerson: '',
      haaId: '',
      contactId: '',
      type: '',
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      success: '',
      surveyData: '',
      userSurveyData: [],
      userRemovedSurveyData: [],
      surveyId: '',
      economy: [],
      social: [],
      environment: [],
      appointmentId: ''
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    var surveyId = searchParams.get('surveyId')
    this.surveyId = surveyId
    var type = searchParams.get('type')
    this.type = type
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    this.userSurveyData = JSON.parse(localStorage.getItem('userSurvey'))
    this.userSurveyData['KlimaSurvey' + this.type] = []
    this.displaySurvey()
  },
  methods: {
    displaySurvey () {
      /* eslint-disable no-unused-vars */
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: JSON.stringify({
          operation: 'getSurvey'
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          var type = 'KlimaSurvey' + this.type
          if (res.success) {
            this.surveyData = res.data[type]
            this.addClassToLastTab()
            this.surveyLoading = false
          } else {
            this.$toastr('error', 'Error in displaySurvey()')
          }
        },
        response => {
          this.$toastr('error', 'Error in displaySurvey()')
        }
      )
      this.surveyLoading = true
    },
    gotoRegistration () {
      this.$router.push('/klima/registration')
    },
    addClassToLastTab () {
      setTimeout(function () {
        document.querySelector('.wizard-tab-container:last-child').classList.add('last')
      }, 3000)
    },
    validateSteps () {
      var tab = document.querySelectorAll('.wizard-tab-container')
      var type = 'KlimaSurvey' + this.type
      var validation = ''
      for (var i = 0; i < tab.length; i++) {
        if (!tab[i].hasAttribute('aria-hidden')) {
          var classList = tab[i].getAttribute('class').split(' ')
          var input = document.querySelectorAll('.wizard-tab-container.' + classList[1] + ' input')
          var inputCount = 0
          var inputYes = false
          var id = ''
          var title = document.querySelector('.wizard-tab-container.' + classList[1] + ' #survey-title').innerText
          for (var x = 0; x < input.length; x++) {
            if (input[x].checked === true) {
              id = input[x].id.split('-')
              if (input[x].classList.contains('yes')) {
                inputYes = true
              } else if (input[x].classList.contains('no')) {
                inputYes = false
              }
              inputCount++
            }
          }
          if (inputCount > 0) {
            if (inputYes) {
              var idExist = false
              for (var j = 0; j < this.userSurveyData[type].length; j++) {
                if (this.userSurveyData[type][j].typeId === id[1]) {
                  idExist = true
                }
              }
              if (!idExist) {
                this.userSurveyData[type].push(
                  {
                    typeId: parseInt(id[1]),
                    title: title.toLowerCase(),
                    value: 1
                  })
              }
            }
            if (!tab[i].classList.contains('last')) {
              validation = true
            } else {
              this.onComplete()
            }
          } else {
            validation = false
            this.$toastr('error', 'Vælg et svar')
          }
        }
      }
      return validation
    },
    saveUserSurvey () {
      var economy = []
      for (var x = 0; x < this.userSurveyData['KlimaSurveyEconomy'].length; x++) {
        var economyId = this.userSurveyData['KlimaSurveyEconomy'][x].typeId
        var economyTitle = this.userSurveyData['KlimaSurveyEconomy'][x].title
        var economyValue = this.userSurveyData['KlimaSurveyEconomy'][x].value
        economy.push(
          {
            usereconomyId: 0,
            economyId: parseInt(economyId),
            title: economyTitle,
            value: parseInt(economyValue)
          })
      }
      var social = []
      for (var j = 0; j < this.userSurveyData['KlimaSurveySocial'].length; j++) {
        var socialId = this.userSurveyData['KlimaSurveySocial'][j].typeId
        var socialTitle = this.userSurveyData['KlimaSurveySocial'][j].title
        var socialValue = this.userSurveyData['KlimaSurveySocial'][j].value
        social.push(
          {
            usersocialId: 0,
            socialId: parseInt(socialId),
            title: socialTitle,
            value: parseInt(socialValue)
          })
      }
      var environment = []
      for (var k = 0; k < this.userSurveyData['KlimaSurveyEnvironment'].length; k++) {
        var environmentId = this.userSurveyData['KlimaSurveyEnvironment'][k].typeId
        var environmentTitle = this.userSurveyData['KlimaSurveyEnvironment'][k].title
        var environmentValue = this.userSurveyData['KlimaSurveyEnvironment'][k].value
        environment.push(
          {
            usersocialId: 0,
            environmentId: parseInt(environmentId),
            title: environmentTitle,
            value: parseInt(environmentValue)
          })
      }
      var fag = []
      for (var l = 0; l < this.userSurveyData['KlimaSurveyFag'].length; l++) {
        var fagId = this.userSurveyData['KlimaSurveyFag'][l].typeId
        var fagTitle = this.userSurveyData['KlimaSurveyFag'][l].title
        var fagValue = this.userSurveyData['KlimaSurveyFag'][l].value
        fag.push(
          {
            userfagId: 0,
            fagId: parseInt(fagId),
            title: fagTitle,
            value: parseInt(fagValue)
          })
      }

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: JSON.stringify({
          klimasurveryId: this.surveyId,
          operation: 'addSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          economy: economy,
          social: social,
          environment: environment,
          fag: fag
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.gotoSurvey()
            this.surveyLoading = false
            this.$toastr('success', 'Opdateret')
          } else {
            this.$toastr('error', 'Error in saveUserSurvey()')
          }
        },
        response => {
          this.$toastr('error', 'Error in saveUserSurvey()')
        }
      )
      this.surveyLoading = true
    },
    onComplete () {
      this.saveUserSurvey()
    },
    gotoSurvey () {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    }
  },
  computed: {}
}
</script>
<template>
<div id="editSurvey" class="animated fadeIn">
    <!-- mobile view -->
    <div class="col-12 lg-col-4 md-col-9 py3 shadow mx-auto mt3">
      <div @click="gotoSurvey()" class="clearfix primarycolor flex justify-start items-center pointer">
        <span class="mr1"><i class="el-icon-back"></i></span>
        <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
      </div>
      <div class="py2"></div>
      <!-- <div class="flex justify-start items-center px0 mt3">
        <div class="col-12 px0">
          <el-progress stroke-linecap="square" :percentage="100" :show-text=false color="rgba(77, 207, 85, 1.0)"></el-progress>
        </div>
      </div> -->
      <div class="clearfix mt3 px3 pt2 pb3 highlights relative">
        <div class="absolute center top-0 left-0 right-0" style="top:-18px;">
          <img src="static/svg/h.svg" width="36" height="36" alt="">
        </div>
        <div class="clearfix" v-if="surveyLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div v-else>
          <form-wizard ref="wizard" title="" v-if="!success" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949" class="px1">
            <tab-content title="1" :class="'survey-' + index" v-for="(survey, index) in surveyData" :key="index" :before-change="validateSteps">
              <div class="clearfix">
                <p class="h4 gibson semi-bold center primarycolor line-height-1">{{type}}</p>
                <div class="py2"></div>
                <p id="survey-title" class="h3 regular center gibson darkblue line-height-3 caps">
                  {{survey}}
                </p>
                <div class="py1"></div>
                <div class="flex col-12 px0 my2">
                  <div class="col col-6 px1 editSurvey">
                    <div class="center itemSelect relative">
                      <input :id="'isYes-' + index" :name="'radio-' + index" class="col-12 fullHeight absolute left-0 z2 pointer yes" type="radio" style="display: block; opacity: 0;">
                      <label for="isYes" class="yes pointer block center col-12 p2 border green-border">
                          <i class="h2 el-icon-check"></i>
                      </label>
                    </div>
                  </div>
                  <div class="col col-6 px1 editSurvey">
                    <div class="center itemSelect relative">
                      <input :id="'isNo-' + index" :name="'radio-' + index" class="col-12 block fullHeight absolute left-0 z2 pointer no" type="radio" style="display: block; opacity: 0;">
                      <label for="isNo" class="no pointer block center col-12 p2 border red-border">
                        <i class="h2 el-icon-close"></i>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
            <template slot="footer" slot-scope="props">
              <div class="wizard-footer-left flex-auto">
                <wizard-button @click.native="props.prevTab()" class="flex items-start justify-start">
                  <span class="block flex flex-column justify-start items-start">
                    <span class="block flex justify-start">
                      <i class="el-icon-back"></i>
                    </span>
                    <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Tilbage</span>
                  </span>
                </wizard-button>
              </div>
              <div class="wizard-footer-right flex-auto">
                <wizard-button @click.native="props.nextTab()" class="flex flex-column items-end justify-end px0 col-12">
                  <span class="block flex flex-column justify-end items-end">
                    <span class="block flex justify-end"><i class="el-icon-right"></i></span>
                    <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">Næste</span>
                  </span>
                </wizard-button>
                <!-- <wizard-button type="button" v-if="props.isLastStep" @click.native="onComplete" class="flex flex-column items-end justify-end px0 col-12">
                  <span class="block flex flex-column justify-end items-end">
                    <span class="block flex justify-end"><i class="el-icon-right"></i></span>
                    <span class="h5 gibson line-height-1 mt2 regular darkblue mb0 block">
                      {{props.isLastStep ? 'Færdig' : 'Næste'}}
                    </span>
                  </span>
                </wizard-button> -->
              </div>
            </template>
          </form-wizard>
        </div>
      </div>
      <!-- progress indicator -->
      <div class="hide clearfix">
        <b-progress height="4px" :value="value" :max="max"></b-progress>
      </div>
      <div class="hide flex col-12 px0 my2">
          <button @click="gotoRegistration()" class="col-12 outlined-disabled-button px2 py3 h4 regular gibson line-height-1">
              <span>Næste</span>
              <span><i class="el-icon-arrow-right"></i></span>
          </button>
      </div>
      <div class="py4"></div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<style lang="less">
.vue-form-wizard .wizard-header {
  height:0px;
  padding:0;
}
.progress {
    background-color: rgba(178, 190, 195, 0.6);
}
.itemSelect {
    input[type="radio"] {
      display: none;
    }
    input[type="radio"] + label {
      display: block;
      background-color: white;
      transition: background-color 0.5s ease;
    }
    .yes {
        color: rgba(77, 207, 85, 1.0);
        border: 2px solid currentColor;
    }
    .no {
        color: rgba(207, 0, 15, 1.0);
        border: 2px solid currentColor;
    }
    input[type="radio"]:checked + label.yes {
      background-color: rgba(77, 207, 85, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
    input[type="radio"]:checked + label.no {
      background-color: rgba(207, 0, 15, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
  }
#editSurvey .wizard-tab-content {
  padding-left: 0;
  padding-right: 0;
}
#editSurvey .wizard-card-footer {
  padding: 0;
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// editsurvey.vue?28040e14